module.exports = __webpack_public_path__ + "static/img/parallax4.4cc6a816.jpg";